import React from 'react'
import { BLink, BText, BTitle } from '@prague-digi/ui-components'

import { InfoCheckbox, PageControlButtons } from '../../../../components'
import messages from '../../../../i18n'

interface Props {
  continueMobile: Function
  showModal: Function
  translate: Function
}

export const IdentityIntro: React.FC<Props> = ({
  continueMobile,
  showModal,
  translate,
}: Props): React.ReactElement<Props> => (
  <>
    <BTitle type="h3">{translate(messages.identity.intro.title)}</BTitle>
    <BText theme="mb-0 pb-1">{translate(messages.identity.intro.text)}</BText>
    <BLink onClick={showModal}>
      <BText>{translate(messages.identity.intro.modalLink)}</BText>
    </BLink>
    <BTitle type="h4">{translate(messages.identity.intro.subHeader)}</BTitle>
    <InfoCheckbox className="mt-2">{translate(messages.identity.intro.idCard)}</InfoCheckbox>
    <InfoCheckbox className="mt-2">
      {translate(messages.identity.intro.drivingLicence)}
    </InfoCheckbox>
    <InfoCheckbox className="mt-2">{translate(messages.identity.intro.mobilePhone)}</InfoCheckbox>

    <PageControlButtons onSubmit={continueMobile} />
  </>
)
